class StdoutTransport {
    formatter;
    // oxlint-disable-next-line typescript/parameter-properties
    constructor(formatter) {
        this.formatter = formatter;
    }
    write(rawLog) {
        // oxlint-disable-next-line no-console
        console.log(this.formatter.format(rawLog));
    }
}

export { StdoutTransport };
//# sourceMappingURL=Stdout.js.map
